import SummaryHeaderWrapper from './SummaryHeaderWrapper';

export default SummaryHeaderWrapper;
